const ROOT_API_URL = 'https://api.borsodidavid.com';
// const ROOT_API_URL = 'http://localhost:3000';

export default ROOT_API_URL;


// WEBPACK FOOTER //
// ./src/utils/RootApiUrl.js